// state/workspace/workspace.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkspaceState } from '../../models/workspace.model';

export const selectWorkspaceState = createFeatureSelector<WorkspaceState>('workspace');

export const selectAllWorkspaces = createSelector(
  selectWorkspaceState,
  (state: WorkspaceState) => state.workspaces
);

export const selectWorkspacesLoading = createSelector(
  selectWorkspaceState,
  (state: WorkspaceState) => state.loading
);

export const selectWorkspacesError = createSelector(
  selectWorkspaceState,
  (state: WorkspaceState) => state.error
);

export const selectSelectedWorkspace = createSelector(
  selectWorkspaceState,
  (state: WorkspaceState) => state.selectedWorkspace
);

export const selectWorkspaceById = (id: string) => createSelector(
  selectAllWorkspaces,
  (workspaces) => workspaces.find(workspace => workspace.id === id)
);

export const selectWorkspaceCount = createSelector(
  selectAllWorkspaces,
  (workspaces) => workspaces.length
);

export const selectWorkspacesWithFiles = createSelector(
  selectAllWorkspaces,
  (workspaces) => workspaces.filter(workspace => workspace.total_files > 0)
);

export const selectDefaultWorkspace = createSelector(
  selectAllWorkspaces,
  (workspaces) => workspaces.find(workspace => workspace.is_default)
);

export const selectWorkspacesSortedByDate = createSelector(
  selectAllWorkspaces,
  (workspaces) => [...workspaces].sort((a, b) =>
    new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  )
);

export const selectWorkspacesSortedByName = createSelector(
  selectAllWorkspaces,
  (workspaces) => [...workspaces].sort((a, b) => a.name.localeCompare(b.name))
);

export const selectWorkspacesWithPendingFiles = createSelector(
  selectAllWorkspaces,
  (workspaces) => workspaces.filter(workspace => workspace.pending_files > 0)
);

export const selectTotalFileSize = createSelector(
  selectAllWorkspaces,
  (workspaces) => workspaces.reduce((total, workspace) => total + workspace.total_file_size, 0)
);
